import { toCamelCaseProperties } from '@fixit/utils';
import moment from 'moment'

export default class Treatment {
    /**
         * 
         * TO BE REMOVED: (Not used in order details)
         *     - employeeImgUrl
         *     - saleBonuspointsEarned
         *     - saleBonuspointsUsed
         * 
         * 
         *  TO BE ADDED:
         *     - treatmentStartTime
         *     - treatmentEndTime
         * 
         */
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
        this.base64EmployeeId = args.base64EmployeeId || ''
        this.base64TreatmentId = args.base64TreatmentId || ''
        this.bundleId = args.bundleId || null
        this.durationInMinutes = args.durationInMinutes
        this.onlineTreatmentTime = args.onlineTreatmentTime || 0
        this.employeeId = args.employeeId || ''
        this.employeeName = args.employeeName || ''
        this.employeeWebId = args.employeeWebId || ''
        this.price = args.price || null
        this.treatmentId = args.treatmentId || ''
        this.treatmentName = args.treatmentName || ''
        this.urlSafeEmployeeName = args.urlSafeEmployeeName || ''
        this.urlSafeTreatmentName = args.urlSafeTreatmentName || ''
        this.treatmentStartTime = args.treatmentStartTime || null
        this.treatmentEndTime = args.treatmentEndTime || moment(args.treatmentStartTime).add(args.durationInMinutes, 'minutes').toDate()
        this.notBookable = args.notBookable || false
        
	}

	assign(treatment) {
		Object.assign(this, toCamelCaseProperties(treatment));
	}
}
